import axios from "axios"

export default axios.create({baseURL: 'https://yumzserver-9afe753f4e84.herokuapp.com/'})
//export default axios.create({baseURL: 'http://192.168.1.30:8000'})
//export default axios.create({baseURL: 'http://192.168.1.14:8000'})
//export default axios.create({baseURL: 'http://192.168.1.104:8000'})
//export default axios.create({baseURL: 'http://10.45.5.47:8000'})

//172.20.10.12